/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Badge } from 'react-bootstrap'; // eslint-disable-next-line
import { copiriPortalRequest } from '../api/api'; // eslint-disable-next-line
import config from '../config/config'; // eslint-disable-next-line
import CopiriLoader from '../common/CopiriLoader';
import UserMemberShipInformationAccordion from './accordion/UserMemberShipInformationAccordion';
const UserMemebrShipInformation = ({ data, pageLanguageContent, profileId, showMemberShipTabData, updateData }) => {
	const [membershipData, setMembershipData] = useState([]);
	const [showData, setShowData] = useState(false);
	const [memebrshipStatus, setMemberStatus] = useState([]);
	const [officeRoles, setOfficeRoles] = useState([]); // eslint-disable-next-line
	useEffect(() => {
		if (showMemberShipTabData && membershipData.length <= 0) {
			getStatus();
			getRoles();
			getMemebrShipInformationData(profileId);
			localStorage.setItem('active_profile_id', profileId);
		}
		// eslint-disable-next-line
	}, [showMemberShipTabData, data]);

	const getStatus = () => {
		setMemberStatus([]);
		copiriPortalRequest('/canon/types/status', config.app_version, 'get')
			.then(response => {
				if (response.data && response.data.length > 0) {
					setMemberStatus(response.data);
				}
			})
			.catch(error => {});
	};

	const getRoles = () => {
		var org_id = localStorage.getItem('selected_org_id');
		copiriPortalRequest('/organizations/' + org_id + '/roles', config.app_version, 'get')
			.then(response => {
				if (response.data.length > 0) {
					setOfficeRoles(response.data);
				}
			})
			.catch(error => {});
	};

	function getMemebrShipInformationData(id) {
		setShowData(false);
		//id=564748558;
		copiriPortalRequest('/users/' + id + '/memberships', config.app_version, 'get', data)
			.then(response => {
				var arr = [];
				for (const key in response.data.memberships) {
					arr.push(response.data.memberships[key]);
				}
				parentChildGrouping(data?.memberships);
				setShowData(true);
			})
			.catch(error => {
				setMembershipData([]);
				setShowData(true);
			});
	}

	function parentChildGrouping(arr) {
		setMembershipData([]);
		var parentArr = [];
		var childArr = []; // eslint-disable-next-line
		var combinedArr = [];
		for (var i = 0; i < arr.length; i++) {
			if (arr[i]['parent_id']) {
				childArr.push(arr[i]);
			} else {
				parentArr.push(arr[i]);
			}
		}
		for (var k = 0; k < parentArr.length; k++) {
			combinedArr.push(parentArr[k]);
			for (var m = 0; m < childArr.length; m++) {
				if (childArr[m]['parent_id'] === parentArr[k]['org_id']) {
					combinedArr.push(childArr[m]);
				}
			}
		}
		if (combinedArr.length > 0) {
			setMembershipData(combinedArr);
		}
	}

	return (
		<>
			<fieldset className='border p-2'>
				<legend className='w-auto'>{pageLanguageContent['PRL080'] ? pageLanguageContent['PRL080'] : ''}</legend>
				<Row>
					<Col lg={12} className='text-right'>
						<Badge bg={''} className='badge badge-soft-info' role="button" style={{marginRight:'-8px'}}>
							<i className="far fa-plus" ></i>
						</Badge>
					</Col>
				</Row>
				
				{showData ? (
					<>
						{membershipData && membershipData.length > 0 ? (
							<UserMemberShipInformationAccordion
								membershipData={membershipData}
								showData={showData}
								data={data}
								pageLanguageContent={pageLanguageContent}
								profileId={profileId}
								memebrshipStatus={memebrshipStatus}
								updateData={updateData}
								officeRoles={officeRoles}
							/>
						) : (
							<p>{pageLanguageContent['PRL086'] ? pageLanguageContent['PRL086'] : ''}</p>
						)}
					</>
				) : (
					<CopiriLoader />
				)}
			</fieldset>
		</>
	);
};
export default UserMemebrShipInformation;
